import { useMapContext } from '@components/map/MapContext';
import { ANIMATION_DURATION, BEARING_NORTH, PITCH_FLAT, PITCH_TILT } from '@utils/map/map.constants';
import { useEffect, useRef } from 'react';
import { useMap } from 'react-map-gl/mapbox';

import { MapIdEnum, ViewMode } from '@/types/map.types';

export const useMapPitchAndBearing = (mapId: MapIdEnum) => {
  const { [mapId]: mapRef } = useMap();
  const map = mapRef?.getMap();
  const { isNorthLocked, viewMode } = useMapContext();

  const prevViewModeRef = useRef<ViewMode | null>(null);

  useEffect(() => {
    if (!map) return;

    const prevViewMode = prevViewModeRef.current;

    if (viewMode === '2D') {
      if (map.getPitch() !== PITCH_FLAT) {
        map.easeTo({ pitch: PITCH_FLAT, duration: ANIMATION_DURATION });
      }

      if (isNorthLocked) {
        if (map.getBearing() !== BEARING_NORTH) {
          map.rotateTo(BEARING_NORTH, { duration: ANIMATION_DURATION });
        }
        map.dragRotate.disable();
        map.dragRotate._mouseRotate._enabled = false;
        map.dragRotate._mousePitch._enabled = false;
      } else {
        map.dragRotate.enable();
        map.dragRotate._mouseRotate._enabled = true;
        map.dragRotate._mousePitch._enabled = false;
      }
    }

    if (viewMode === '3D') {
      if (prevViewMode === '2D' && map.getPitch() !== PITCH_TILT) {
        map.easeTo({ pitch: PITCH_TILT, duration: ANIMATION_DURATION });
      }

      if (isNorthLocked) {
        if (map.getBearing() !== BEARING_NORTH) {
          map.rotateTo(BEARING_NORTH, { duration: ANIMATION_DURATION });
        }
        map.dragRotate.enable();
        map.dragRotate._mouseRotate._enabled = false;
        map.dragRotate._mousePitch._enabled = true;
      } else {
        map.dragRotate.enable();
        map.dragRotate._mouseRotate._enabled = true;
        map.dragRotate._mousePitch._enabled = true;
      }
    }
  }, [map, viewMode, isNorthLocked]);
};
